import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { Observable } from "rxjs";
import { IRound } from "../interfaces";
import { RoundRepository } from "../round.repository";
import { map } from "rxjs/operators";

@Injectable()
export class GetRoundMultiplierUseCase implements IUseCase<void, Observable<number>> {
    constructor(private roundRepository: RoundRepository) {
    }

    execute(): Observable<number> {
        return this.roundRepository.get().pipe(map((round: IRound) => round.multiplier));
    }
}
